import React from 'react';

import './style.css';

const Legal = () => {
  return (
    <div className="legal-info">
      <div>
        <span>&copy;{new Date().getFullYear()} The Slate Pages, LLC</span>
      </div>

      <div>
        <span>
          <a
            href="http://slatepages.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            slatepages.com
          </a>
        </span>
        <span>
          <a
            href="https://slatepages.com/terms-of-use/"
            target="_blank"
            rel="noopener noreferrer"
          >
            terms
          </a>
        </span>
        <span>
          <a
            href="https://slatepages.com/terms-of-use/"
            target="_blank"
            rel="noopener noreferrer"
          >
            privacy
          </a>
        </span>
      </div>
    </div>
  );
};

export default Legal;
